import {DataSeries, GraphConfig, GraphType, ParsedGraphConfig, YAxisConfig} from '../../../types/GraphTypes';

export function mapGraphRendererConfig(graphConfig: GraphConfig | null): ParsedGraphConfig {
  if (!graphConfig) {
    return {
      chartType: GraphType.LINE,
      xAxis: null,
      yAxes: [],
      dataSeries: [],
    };
  }

  // Convert string to enum if needed, default to LINE
  let chartType: GraphType;
  if (graphConfig.graphType === GraphType.BAR || graphConfig.graphType === 'bar') {
    chartType = GraphType.BAR;
  } else if (graphConfig.graphType === GraphType.SCATTER || graphConfig.graphType === 'scatter') {
    chartType = GraphType.SCATTER;
  } else {
    chartType = GraphType.LINE;
  }

  const xAxis = graphConfig.x || null;

  // Extract y axes (y1, y2) and their series
  const yAxes: Array<{id: string; config: YAxisConfig}> = [];
  const dataSeries: DataSeries[] = [];

  // Check for y1 and y2 specifically
  ['y1', 'y2'].forEach((key) => {
    const yConfig = graphConfig[key as keyof GraphConfig] as YAxisConfig | undefined;
    if (yConfig && typeof yConfig === 'object' && 'label' in yConfig && 'data' in yConfig) {
      yAxes.push({id: key, config: yConfig});

      // Extract series from yConfig.data
      if (yConfig.data && typeof yConfig.data === 'object') {
        Object.keys(yConfig.data).forEach((seriesKey) => {
          const seriesData = yConfig.data[seriesKey];
          // Include series even if empty (might be intentional)
          if (Array.isArray(seriesData)) {
            dataSeries.push({
              key: `${key}_${seriesKey}`,
              data: seriesData,
              name: seriesKey,
              yAxisId: key,
            });
          }
        });
      }
    }
  });

  return {
    chartType,
    xAxis,
    yAxes,
    dataSeries,
  };
}
